export default __webpack_public_path__ + "static/media/bulb.52d1d2a4.svg";